import React, { useState } from "react";
import classNames from "classnames";
import Bouton, { VARIANT } from "../bouton";

import styles from "./accordeonContenu.module.scss";

type PropTypes = {
    children: React.ReactNode;
    className?: string;
    handleParentClick?: Function;
    id?: number;
    isOpen?: boolean;
    titre: string;
};

const AccordeonContenu = ({
    children,
    className = "",
    handleParentClick,
    id,
    isOpen,
    titre,
}: PropTypes) => {
    const [open, setOpen] = useState(isOpen);

    const handleToggle = (val: any) => {
        setOpen(!open);
        if (handleParentClick) {
            handleParentClick(val);
        }
    };

    return (
        <div
            data-component="AccordeonContenu"
            key={id}
            className={classNames(
                {
                    [styles.accordeon]: true,
                    [styles.open]: open,
                    [className]: className,
                    [styles.accordeon]: true,
                },
                "accordeonContenu",
            )}
        >
            <Bouton
                className={styles.mainBtn}
                icon="fleche"
                iconRight
                onClick={handleToggle}
                onClickParam={id}
                variant={VARIANT.LINK}
            >
                {titre}
            </Bouton>

            <div
                className={classNames(
                    {
                        [styles.content]: true,
                    },
                    "accordeonContenuContent",
                )}
            >
                <div
                    className={classNames(
                        {
                            [styles.contentInner]: true,
                        },
                        "accordeonToileContentInner",
                    )}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AccordeonContenu;
